import nativeProxy from './nativeProxy';

export default {};

export enum SharePageName {}

export interface LinkShareParams {
  title?: string; // 分享标题
  content?: string; // 分享的摘要
  icon?: string; // 分享 icon 的 url
  link?: string; // 分享链接
}

export enum BackAction {
  goBack = 'GO_BACK',
  exit = 'EXIT',
}

/**
 * 初始化 link 分享
 * @param params 分享信息
 */
export const InitLinkShare = (params?: LinkShareParams) => {
  const init = () => {
    const {
      title = '希沃学苑：一线教师专属信息化教育培训平台',
      content = '超20000节精彩案例，与百万老师共同学习。',
      icon = `${(window as any).__INITIAL_STATE__.seewoEduUrl}/statics/global/images/logo.png`,
      link = location.href,
    } = params || {};

    if (nativeProxy.isInApp()) {
      // EN5 APP
      (nativeProxy as any).invoke({
        name: 'nShareContent',
        params: {
          title,
          icon,
          link,
          content: content.trim().substring(0, 50),
        },
      });
    } else {
      // 微信
      // TODO 微信分享的处理(预计的需求版本：3.1.8)
    }
  };

  if (params) {
    // 带参数认为是定制页面的分享信息，覆盖 mobilePublicComponent 装饰器的配置
    setTimeout(() => {
      init();
    }, 100);
  } else {
    init();
  }
};

// 获取当前的通信协议版本
export const getPlatform = () =>
  new Promise((resolve, reject) => {
    nativeProxy.invoke({
      name: 'nNormalGetPlatform',
      webCb: () => {
        reject();
      },
      nativeCb: (data) => {
        resolve(data);
      },
    });
  });

// 提醒安卓en5升级
export const remindAndroidUpdate = () => {
  nativeProxy.invoke({
    name: 'nNormalCheckOTA',
    params: {
      alert: true,
    },
  });
};

// 定义回退按钮的行为
export const setBackAction = (action: BackAction) => {
  nativeProxy.invoke({
    name: 'nNormalBackAction',
    params: {
      action,
    },
  });
};

// 是否刘海屏
export const isBangScreen = () => {
  return new Promise((resolve) => {
    nativeProxy.invoke({
      name: 'nNormalGetScreenSafeArea',
      webCb: () => {
        resolve(false);
      },
      nativeCb: (data) => {
        if (nativeProxy.isInApp() && data.bottom === 34) {
          resolve(true);
        }
        resolve(false);
      },
    });
  });
};
